// extracted by mini-css-extract-plugin
export default {"productExpirationOverview":"ProductExpirationOverview_productExpirationOverview__Trae+"};